// 📄 src/pages/AutoReplyBuilder/components/uiTokens.js
import {
  PlayCircle,
  MessageSquareText,
  MessageSquare,
  TextCursorInput,
  Images,
  ListChecks,
  GitBranch,
  Hourglass,
  Tag,
  FileText,
  Search,
  Workflow,
  MousePointerClick,
  Headset,
  ShoppingBag,
  ClipboardCheck,
  ClipboardList,
  ExternalLink,
  LayoutGrid,
  CalendarClock,
  CalendarCheck,
  ListFilter,
  TableProperties,
  PackageCheck,
  Thermometer,
} from "lucide-react";

export const NODE_COLORS = {
  start: "emerald",
  message: "blue",
  whatsapp_flow: "emerald",
  whatsapp_flow_dynamic_options: "cyan",
  schedule_booking: "emerald",
  confirm_booking: "emerald",
  media: "purple",
  button_choice: "purple",
  url_cta: "indigo",
  choice: "purple", // alias
  branch: "amber",
  decision_table: "amber",
  condition: "amber", // alias
  browse_catalogue: "cyan",
  search_catalogue: "cyan",
  present_catalogue_results: "cyan",
  prepare_commerce_service: "cyan",
  review_and_submit: "cyan",
  template: "slate",
  wait: "cyan",
  tag: "green",
  set_lead_temperature: "amber",
  add_flow: "indigo",
  cta_flow: "indigo",
  handover_agent: "indigo",
  default: "slate",
};

export const NODE_ICONS = {
  start: PlayCircle,
  message: MessageSquareText,
  input_capture: TextCursorInput,
  whatsapp_flow: ClipboardList,
  whatsapp_flow_dynamic_options: ListFilter,
  schedule_booking: CalendarClock,
  confirm_booking: CalendarCheck,
  media: Images,
  button_choice: ListChecks,
  url_cta: ExternalLink,
  choice: ListChecks,
  branch: GitBranch,
  decision_table: TableProperties,
  condition: GitBranch,
  browse_catalogue: LayoutGrid,
  search_catalogue: Search,
  present_catalogue_results: ShoppingBag,
  prepare_commerce_service: PackageCheck,
  review_and_submit: ClipboardCheck,
  template: FileText,
  wait: Hourglass,
  tag: Tag,
  set_lead_temperature: Thermometer,
  add_flow: Workflow,
  cta_flow: MousePointerClick,
  handover_agent: Headset,
  default: MessageSquare,
};

export const BUILDER_TOKENS = {
  // Global block wrapper
  node: {
    baseCss: "group relative rounded-xl border bg-white p-0 flex flex-col transition-all duration-200",
    shadowNormal: "shadow-[0_2px_8px_rgba(0,0,0,0.04)]",
    shadowHover: "hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.08)]",
    shadowSelected: "shadow-[0_8px_24px_rgba(16,185,129,0.15)]",
    typography: "text-[10px] font-normal text-slate-800",
  },
  
  // Node Header
  header: {
    baseCss: "flex items-center justify-between rounded-t-xl border-b border-slate-100 bg-slate-50/80 px-3 py-2.5",
    iconWrapper: "flex h-5 w-5 items-center justify-center rounded-md bg-white shadow-sm ring-1 ring-slate-200/50",
    iconSize: "h-3 w-3",
    titleCss: "truncate text-[11px] font-bold uppercase tracking-wider text-slate-700",
  },

  // Ports / Edge Handles
  port: {
    size: "w-3 h-3", // equivalent to 12px
    border: "border-2 border-white",
    shadow: "shadow-[0_0_0_1px_rgba(15,23,42,0.08),0_2px_4px_rgba(15,23,42,0.12)]",
    transition: "transition-colors duration-150",
  },
  
  // Node Inner Body (content blocks)
  body: {
    sectionPadding: "px-2 py-1.5",
    typography: "text-[11px] font-normal leading-relaxed text-slate-700",
    blockWrapper: "rounded-lg border border-slate-100 bg-slate-50",
    hoverableItem: "rounded-lg border border-slate-200 bg-white shadow-[0_1px_2px_rgba(0,0,0,0.02)] transition-colors",
  }
};
